import { NavLink } from "react-router-dom";
import { useVendorDirectoryPaths } from "../../../hooks/useVendorDirectoryPaths";
import { useVendorDirectoryPermissions } from "../../../hooks/useVendorDirectoryPermissions";
import {
  VENDOR_DIRECTORY_PERMISSIONS as P,
  hasVendorDirectoryPermission,
} from "../../../auth/casamapaVendorDirectoryPermissions";
import { useLocale } from "../../../intl";

const COPY_PREFIX = "realEstate.casaMapa.admin.vendorDirectoryWorkspace.ranking";

export default function ClientVendorDirectoryRankingSubnav() {
  const { serviciosBase, isPartnerPortal } = useVendorDirectoryPaths();
  const { permissions } = useVendorDirectoryPermissions();
  const { t } = useLocale();
  const base = `${serviciosBase}/posicionamiento`;

  if (isPartnerPortal) {
    return null;
  }

  const items = [
    { to: base, label: t(`${COPY_PREFIX}.nav.dashboard`), end: true, permission: P.RANKING_VIEW },
    { to: `${base}/modelos`, label: t(`${COPY_PREFIX}.nav.models`), permission: P.RANKING_VIEW },
    { to: `${base}/simulaciones`, label: t(`${COPY_PREFIX}.nav.simulations`), permission: P.RANKING_VIEW },
    { to: `${base}/ejecuciones`, label: t(`${COPY_PREFIX}.nav.runs`), permission: P.RANKING_VIEW },
    { to: `${base}/exclusiones`, label: t(`${COPY_PREFIX}.nav.overrides`), permission: P.RANKING_VIEW },
    { to: `${base}/colocaciones`, label: t(`${COPY_PREFIX}.nav.placements`), permission: P.RANKING_VIEW },
    { to: `${base}/preview`, label: t(`${COPY_PREFIX}.nav.preview`), permission: P.RANKING_PREVIEW },
  ].filter((item) => hasVendorDirectoryPermission(permissions, item.permission));

  return (
    <nav className="cvd-tabs cvd-tabs--nested" aria-label={t(`${COPY_PREFIX}.navAria`)}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `cvd-tab${isActive ? " cvd-tab--active" : ""}`}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
